/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import personTranslations from "./personTranslations";

const customerInsuranceTranslations = {
  policyHolderType: {
    question: "Läuft die Rechtsschutz-Versicherung auf Ihren Namen oder sind Sie über ein Familienmitglied mitversichert?",
    label: "Selbst- oder mitversichert?",
    options: {
      familyMember: {
        label: "Ich bin über ein Familienmitglied mitversichert",
      },
      me: {
        label: "Die Versicherung läuft auf meinen Namen",
      },
    },
  },
  policyHolder: personTranslations,
  insurancePolicyNumber: {
    question: "Wie lautet Ihre Versicherungsnummer?",
    label: "Versicherungsnummer",
  },
  caseReferenceNumber: {
    question: "Sollte Ihnen diese Nummer bereits vorliegen: Wie lautet Ihre Schadens-/Leistungsnummer?",
    label: "Schadens-/Leistungsnummer",
  },
  deductible: {
    question: "Wie hoch ist der mit Ihrer Versicherung vereinbarte Selbstbehalt, den Sie im Falle eines rechtlichen Vorgehens zahlen müssen?",
    label: "Selbstbehalt",
    helperText: "Wenn Sie den Selbstbehalt gerade nicht genau wissen, lassen Sie das Feld einfach leer.",
  },
  insurance: {
    name: {
      label: "Name",
    },
    label: "Versicherungsgesellschaft",
    question: "Bei welcher Rechtsschutzversicherung sind Sie versichert?",
  },
};

export default customerInsuranceTranslations;
